/**
 * DOCS DELETE
 * 
 * module de gestion des suppression 
 * de documents
 * via une popin dans
 * la partie PRO de l'espace mon compte
 */
import $ from "jquery";
import { dialog } from "../../../../components/dialog.js";
const utils = require('../utils.js').default;

const DOCSDelete = (() => {

    const POPIN_DOCUMENTS_DELETE = 'popin-delete-doc';
    const DOM_DOCS_DELETE_POPIN_SHOW = `[data-js-dialog-open="${POPIN_DOCUMENTS_DELETE}"]`;
    const DOM_DOCS_DELETE_POPIN = `[data-js-dialog-id="${POPIN_DOCUMENTS_DELETE}"]`;
    const DOM_DOCS_DELETE = `[data-js-dialog-id="${POPIN_DOCUMENTS_DELETE}"] .js-doc-delete`;

    /**
     * DOCS DELETE (func)
     * 
     * suppression d'un documents
     * @param {*} event 
     */
    const docsDelete = (event) => {
        event.preventDefault();
        let id = $(event.currentTarget).data('doc-id');
        let name = $(event.currentTarget).data('doc-name');
        let groupId = $(event.currentTarget).data('docs-group-id');
        window.DOCS.docsDelete(groupId, id).then((success) => {
            utils.dispatchCustomEvent('NOTIFICATION_DEFAULT', {type:'success', content: `<strong>${name}</strong> - ${success.msg}`})
            utils.dispatchCustomEvent('ANIMATION_DOCS_REMOVE', {id, groupId});
            utils.dispatchCustomEvent('DOCUMENTS_HAS_CHANGED', {event: 'Suppression d\'un document'});   
            utils.dispatchCustomEvent('TRACKERS_DOCUMENTS_DELETE', {name});   
            utils.debug('DOCS DELETE', {name, groupId, id});              
        }).catch((error) => {
            utils.debug('DOCS DELETE', `erreur de suppression du document - ${error}`);
            utils.dispatchCustomEvent('TEMPLATE_ERROR', {error});
        });
        dialog.close();
    };
    /**
     * DOCS DELETE EVENTS
     * 
     * bind des events de suppression
     */
    const docsDeleteEvents = () => {
        $(DOM_DOCS_DELETE).off().on('click', docsDelete);
    };
    /**
     * POPIN OPEN (func)
     * 
     * Ouverture de la popin suppression d'adresse
     * @param {*} event 
     */
    const popinOpen = (event) => {
        event.preventDefault();
        updateTemplate(event);
        docsDeleteEvents();
    };
    /**
     * UPDATE TEMPLATE (func)
     * 
     * Mise à jour du template de la popin 
     * de suppression d'adresse
     * @param {*} event 
     */
    const updateTemplate = (event) => {
        event.preventDefault();
        let data = {
            name: $(event.currentTarget).data('doc-name'),
            id: $(event.currentTarget).data('doc-id'),
            groupId: $(event.currentTarget).data('docs-group-id'),
        };
        utils.dispatchCustomEvent('TEMPLATE_POPIN_UPDATE', {popinTargetID: POPIN_DOCUMENTS_DELETE, data});
    };
    /**
     * INIT (func)
     */
    const init = () => {
        utils.debug('DOCS DELETE', 'initialisation');   
        // déplacement/copie d'un produit dans une autre liste (si pro/connecté)
        $(DOM_DOCS_DELETE_POPIN_SHOW).off().on('click', popinOpen);
    };
    return {init}
})();
export default DOCSDelete;
